import { UseMutationOptions, UseMutationResult, useMutation } from "@tanstack/react-query";
import { IDeleteActionParams, deleteActionWithBody, deleteWorkflowItemAction } from "../actions/sector-workflow.actions";

export interface IUseDeleteMutationParams<TResponse> {
  mutationOptions?: UseMutationOptions<TResponse, Error, IDeleteActionParams>;
}

interface IDeleteWithBodyMutationParams<TBody> {
  uri: string;
  body?: TBody;
}

export const useSectorWorkflowDeleteItem = <TResponse = void>(
  params?: IUseDeleteMutationParams<TResponse>,
): UseMutationResult<TResponse, Error, IDeleteActionParams> => {
  const { mutationOptions } = params ?? {};

  return useMutation<TResponse, Error, IDeleteActionParams>({
    mutationFn: async (mutationParams) => {
      return deleteWorkflowItemAction<TResponse>(mutationParams);
    },
    ...mutationOptions,
  });
};

export const useDeleteWithBodyMutation = <TResponse = void, TBody = unknown>(params?: {
  mutationOptions?: UseMutationOptions<TResponse, Error, IDeleteWithBodyMutationParams<TBody>>;
}) => {
  return useMutation<TResponse, Error, IDeleteWithBodyMutationParams<TBody>>({
    mutationFn: ({ uri, body }) => {
      return deleteActionWithBody<TResponse, TBody>({
        uri,
        body,
      });
    },
    ...params?.mutationOptions,
  });
};
